import React from 'react';

type Props = {
  children: React.ReactNode;
};

const Title = ({children}: Props) => (
  <div className="mb-[50px] pt-[40px] text-center text-[30px] tracking-[0.5px] text-neutral-700">
    {children}
  </div>
);

export default Title;
